import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	newTag: {
		id: 'app.contentCard.newTag',
		defaultMessage: 'New',
		description: 'Decorator for new content',
	},
	label: {
		id: 'app.contentCard.label',
		defaultMessage: 'Content tile for {title}',
		description: 'Screen reader label for content tile',
	},
	labelLocked: {
		id: 'app.contentCard.labelLocked',
		defaultMessage: 'Locked content tile for {title}',
		description: 'Screen reader label for content tile that needs a subscription',
	},
});
